import type { ReactNode } from 'react'
import { useTranslation } from 'react-i18next'
import ConfirmDialog from 'ui/components/ConfirmDialog/ConfirmDialog'

type NewerSubmissionWarningDialogProps = {
  open: boolean
  onClose: () => void
  onConfirm: () => void
  onLoadLatest: () => void
}

export function NewerSubmissionWarningDialog({
  open,
  onClose,
  onConfirm,
  onLoadLatest,
}: NewerSubmissionWarningDialogProps): ReactNode {
  const { t } = useTranslation()

  return (
    <ConfirmDialog
      open={open}
      onClose={onClose}
      onConfirm={onConfirm}
      initialFocus="deny"
      maxWidth="md"
      alternativeButton={{ text: 'Discard my changes and load the latest positions', onClick: onLoadLatest }}
      textObject={{
        title: t('New positions have been submitted'),
        text: t(
          'Positions for this system have been submitted since your table was loaded. If you submit now, the values in your table replace them.'
        ),
        confirm: t('Replace their positions'),
        deny: t('Cancel'),
      }}
    />
  )
}
